import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "recharge-points-main"
};
const _hoisted_2 = {
  class: "recharge-user"
};
const _hoisted_3 = {
  class: "deduction-type"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "points-amount"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "points-amount-edit"
};
const _hoisted_8 = {
  key: 0,
  class: "payment-method"
};
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = {
  key: 1,
  style: {
    "text-align": "right",
    "margin-top": "20px"
  }
};
const _hoisted_11 = {
  class: "benefits-deduction"
};
const _hoisted_12 = {
  style: {
    "text-align": "right",
    "margin-top": "20px"
  }
};
import { ref, onMounted, computed, onUnmounted } from 'vue';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { emitter } from '@/utils/events';
import { getLiveBenefit, payLive, appUserResourceByType } from '@/request/program';
import { useMainStore } from '@/pinia';
import accountDetails from '@/layout/components/accountDetails.vue';
import { PollingTimer } from "@/utils/pollingTimer";
export default /*@__PURE__*/_defineComponent({
  __name: 'livestreamingCredit',
  props: {
    addCommitData: {
      type: [Object, null],
      default: () => ({})
    }
  },
  emits: ['closeDialog'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    let props = __props;
    const store = useMainStore();
    // 用户账户下次
    let amountInfo = computed(() => store.amountInfo);
    let days = ref(null);
    let moneyType = ref(null);
    let userInfo = ref(JSON.parse(localStorage.getItem('userInfo')));
    // 充值金额
    let moneyArrDic = [{
      label: '1',
      value: 1
    }, {
      label: '7',
      value: 7
    }, {
      label: '30',
      value: 30
    }, {
      label: 'add',
      value: null
    }];
    let moneyLoading = ref(false);
    const statusTimer = ref();
    // watch(
    //   () => points.value,
    //   (newMoney) => {
    //     // handChangeFn(newMoney);
    //   }
    // );
    let handChangeFn = value => {
      // moneyLoading.value = true;
      // 检查值是否为100的倍数
      // if (value % 100 !== 0) {
      //   // 不是100的倍数，重置为最接近的100的倍数
      //   points.value = Math.round(value / 100) * 100;
      // }
      // 获取充值二维码
      // createWxCodePayOrder({ businessType: '积分', amount: points.value })
      //   .then((res) => {
      //     codeImg.value = res.data.data.codeUrl;
      //     orderPayStatus({ orderPaymentId: res.data.data.orderPaymentId });
      //   })
      //   .finally(() => {
      //     moneyLoading.value = false;
      //   });
    };
    let handClickFn = ({
      value,
      label
    }) => {
      console.log('itemitem', value);
      if (value) days.value = value;else days.value = 35;
      moneyType.value = label;
    };
    // const orderPayStatus = ({ orderPaymentId }) => {
    //   // 监听付款情况
    //   getStatus({ orderPaymentId }).then((res) => {
    //     if (res.data.data === '待付款') {
    //       statusTimer.value = setTimeout(() => {
    //         orderPayStatus({ orderPaymentId });
    //       }, 1000);
    //     }
    //     if (res.data.data === '已完成') {
    //       emits('closeDialog');
    //       // 刷新积分
    //       emitter.emit('refreshIntegral')
    //       ElMessage.success('支付成功');
    //     }
    //   });
    // };
    onMounted(() => {
      getLiveBenefitFn();
      getAppUserResourceByType();
      // clearTimeout(statusTimer.value);
    });
    // 扣除详情
    let livePriceData = ref({});
    let points = computed(() => {
      var _livePriceData$value;
      return +((_livePriceData$value = livePriceData.value) === null || _livePriceData$value === void 0 ? void 0 : _livePriceData$value.price) * +days.value;
    });
    // 获取直播的权益
    let getLiveBenefitFn = () => {
      getLiveBenefit().then(res => {
        let {
          data
        } = res.data;
        livePriceData.value = data;
      });
    };
    // 开通直播
    let openLive = resourceType => {
      if (deductionType.value === 'points') {
        let {
          availableRechargeBalance
        } = store.amountInfo;
        if (points.value > availableRechargeBalance) {
          ElMessage.warning('积分不足，请先充值积分');
          return;
        }
        payLive({
          day: days.value,
          ...props.addCommitData,
          resourceType
        }).then(res => {
          if (res.data.code === 200) {
            ElMessage.success('开通成功');
            emits('closeDialog');
            // 刷新积分
            emitter.emit('refreshIntegral');
          }
        });
      } else {
        payLive({
          day: benefitsDays.value,
          ...props.addCommitData,
          resourceType
        }).then(res => {
          if (res.data.code === 200) {
            ElMessage.success('开通成功');
            emits('closeDialog');
            // 刷新积分
            emitter.emit('refreshIntegral');
          }
        });
      }
    };
    let deductionType = ref('points');
    const deductionTypes = computed(() => {
      const types = [{
        type: 'points',
        label: '积分抵扣'
      }];
      if (maxBenefitsDays.value) {
        types.push({
          type: 'benefits',
          label: '权益抵扣'
        });
      }
      return types;
    });
    let benefitsDays = ref(1);
    let maxBenefitsDays = ref(1);
    let getAppUserResourceByType = () => {
      appUserResourceByType(["LIVE"]).then(res => {
        let {
          data,
          code
        } = res.data;
        if (code !== 200) return;
        if (data !== null && data !== void 0 && data.length) maxBenefitsDays.value = data[0].usableCount;else maxBenefitsDays.value = 0;
      });
    };
    // 更新余额的方法
    const updateBalance = async () => {
      let stopPolling = true;
      try {
        await store.getAppUserAmountInfoFn();
        stopPolling = true;
      } catch (error) {
        stopPolling = false;
      }
      return !stopPolling;
    };
    let timer = new PollingTimer(updateBalance, 3 * 1000);
    timer.start();
    onUnmounted(() => {
      timer.cancel();
    });
    return (_ctx, _cache) => {
      var _unref2;
      const _component_Minus = _resolveComponent("Minus");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_Plus = _resolveComponent("Plus");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_slider = _resolveComponent("el-slider");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h3", null, "用户：" + _toDisplayString((_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.nickname), 1)]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deductionTypes.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.type,
          class: _normalizeClass(["deduction-type-item", {
            active: _unref(deductionType) === item.type
          }]),
          onClick: $event => _isRef(deductionType) //@ts-ignore
          ? deductionType.value = item.type : deductionType = item.type
        }, _toDisplayString(item.label), 11, _hoisted_4);
      }), 128))]), _unref(deductionType) === 'points' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(accountDetails, {
        arrowRighBtn: false,
        availableRechargeBalance: _unref(amountInfo).availableRechargeBalance
      }, null, 8, ["availableRechargeBalance"]), _createElementVNode("h3", null, "开通天数：" + _toDisplayString(_unref(days)), 1), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(moneyArrDic), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['points-amount-title', item.label === _unref(moneyType) ? 'active' : null]),
          key: index,
          onClick: $event => _unref(handClickFn)(item)
        }, _toDisplayString(item.value ? item.label + '天' : '其他'), 11, _hoisted_6);
      }), 128))]), _createVNode(_Transition, {
        name: "fade"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input_number, {
          modelValue: _unref(days),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(days) ? days.value = $event : days = $event),
          size: "large",
          style: {
            "width": "100%"
          },
          min: 1,
          max: 99999999,
          step: 10,
          "controls-position": "right"
        }, {
          "decrease-icon": _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Minus)]),
            _: 1
          })]),
          "increase-icon": _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Plus)]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])], 512), [[_vShow, _unref(moneyType) === 'add']])]),
        _: 1
      }), _cache[7] || (_cache[7] = _createElementVNode("h3", null, [_createTextVNode("支付方式："), _createElementVNode("i", {
        class: "ri-coin-fill",
        style: {
          "font-size": "20px",
          "color": "#ff9900"
        }
      })], -1)), _unref(points) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[4] || (_cache[4] = _createTextVNode(" 需抵扣积分：")), _createElementVNode("span", null, _toDisplayString(_unref(points)), 1), _cache[5] || (_cache[5] = _createTextVNode("积分 "))])])) : _createCommentVNode("", true), _unref(points) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_button, {
        size: "large",
        style: {
          "width": "100%"
        },
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => _unref(openLive)(''))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("开通")])),
        _: 1
      })])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(accountDetails, {
        arrowRighBtn: false,
        labelText: "直播权益剩余天数",
        availableRechargeBalance: _unref(maxBenefitsDays),
        backgroundIcon: "ri-medal-fill"
      }, null, 8, ["availableRechargeBalance"]), _createElementVNode("div", _hoisted_11, [_cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "benefits-title"
      }, "抵扣天数：", -1)), _createVNode(_component_el_slider, {
        modelValue: _unref(benefitsDays),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(benefitsDays) ? benefitsDays.value = $event : benefitsDays = $event),
        min: 1,
        max: _unref(maxBenefitsDays),
        "show-input": "",
        class: "benefits-slider"
      }, null, 8, ["modelValue", "max"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
        size: "large",
        style: {
          "width": "100%"
        },
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => _unref(openLive)('LIVE'))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("开通")])),
        _: 1
      })])], 64))]);
    };
  }
});